


























































import { bookGoodsModelProvider } from '../model'
import { defineClassComponent } from '@/hooks'
import { navigateTo } from '@/router'
import { onActivated, ref } from '@vue/composition-api'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        onActivated(() => (this.categoryIndex.value = 0))
      }

      bookGoodsModel = bookGoodsModelProvider.inject()

      categoryIndex = ref(0)

      showMore = ref(false)

      handleCategoryClick = (categoryIndex: number) => {
        navigateTo('GoodsIndex', {
          id: this.bookGoodsModel.value.relatedCommodities[categoryIndex]
            .relatedCommodityId,
        })
      }
    },
)
